/**
 * SpecialPurposePersonDialog — bucket dispatcher for Special Purpose entities.
 *
 * 7-bucket structure (Bill 2026-05-05 lock). This bucket holds niche
 * regulated trust-like vehicles:
 *   - QIT (Qualified Income Trust / Miller Trust)
 *   - Self-Settled SNT (Special Needs Trust)
 *   - IOLTA (Lawyer Trust — MO Bar regulated, static EIN)
 *   - ICS_Personal / ICS_Business (admin-disabled by default — IntraFi sweeps)
 *   - MedicalSetAside (admin-disabled — WC/PI Medicare set-aside)
 *   - USDAGrant (admin-disabled — restricted-use USDA Rural Development grant)
 *
 * Each subtype has a distinct procedural flow that must conform to
 * DESIGN-BIBLE.md §2 (canonical Personal Add Flow shape). Bill's
 * procedural decision trees per subtype are still pending — this dialog
 * ships as a thin stub that defers to TrustPersonDialog (closest existing
 * shape) until per-subtype procedural input lands.
 *
 * TODO when Bill provides procedural input:
 *   - Per-subtype cohort grid + doc tile sets per DESIGN-BIBLE.md §2 step 4
 *   - QIT-specific Medicaid-eligibility income-routing fields
 *   - SNT-specific disability-eligibility + grantor-not-signer rule
 *   - IOLTA-specific Missouri Bar registration + static EIN auto-fill
 *   - ICS sweep auto-fill from Finance email (admin-enabled flow)
 *   - MSA / USDA Grant restricted-use designation fields
 */
import { TrustPersonDialog } from '../trust/TrustPersonDialog';
import type { ComponentProps } from 'react';

type Props = ComponentProps<typeof TrustPersonDialog>;

export function SpecialPurposePersonDialog(props: Props): JSX.Element | null {
  // Stub — Trust shape is the closest match for QIT/SNT/IOLTA which are
  // structurally trusts. ICS/MSA/USDAGrant fall through to the same shape
  // until per-subtype curated flows land.
  return <TrustPersonDialog {...props} />;
}
